
export const formatToCurrency = (amount) => {
  if(amount !== undefined || amount !== ""){
    let amountFloat = parseFloat(amount)
    return  amountFloat.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  }else{
    return amount
  }
}
